<script lang="ts">
    import TemplateSettingsGeneral from "./TemplateSettingsGeneral.svelte";
    import {_} from 'svelte-i18n';
    import {customerSettings} from '../../../stores/api';
    import SettingsRow from './SettingsRow.svelte';
    import SettingsRowLabel from './SettingsRowLabel.svelte';
    import SettingsRowValue from './SettingsRowValue.svelte';
    import Select from '../../shared/Select.svelte';
    import { AVAILABLE_OVERLOAD_ACTIONS } from './settings';
    import { debug } from '../../../stores/store';
    import Checkbox from '../../shared/Checkbox/Checkbox.svelte';

    export let update: () => void;

</script>


<TemplateSettingsGeneral>
    <div slot="label">{$_('vehicle_limits_during_planning')}</div>
    <div slot="content">
        <SettingsRow>
            <SettingsRowLabel>
                {$_('apply_load_limits_recalculation')}
            </SettingsRowLabel>
            <SettingsRowValue>
                <Checkbox
                    bind:checked={$customerSettings.vehicle_overload_checking_when_planning.check_weight_limit}
                    label=""
                    onChange={s => {
                        update();
                        return true;
                    }}
                />
            </SettingsRowValue>
        </SettingsRow>
        <SettingsRow>
            <SettingsRowLabel>
                {$_('apply_parcel_limits_recalculation')}
            </SettingsRowLabel>
            <SettingsRowValue>
                <Checkbox
                    bind:checked={$customerSettings.vehicle_overload_checking_when_planning.check_parcel_limit}
                    label=""
                    onChange={s => {
                        update();
                        return true;
                    }}
                />
            </SettingsRowValue>
        </SettingsRow>
    </div>
</TemplateSettingsGeneral>
